import { FC } from 'react';
import IconClose from '@mui/icons-material/Close';
import IconDocument from 'src/assets/images/icons/document.svg';
import { IconButton } from '@mui/material';
import { useDeleteAttachment } from 'src/use-cases/invoice/useDeleteAttachment';
import { ICardFileProps } from './types';

interface IDeleteButtonProps {
  onClick: () => void;
}

const DeleteButton = ({ onClick }: IDeleteButtonProps) => (
  <div className='w-16 mr-4'>
    <IconButton onClick={onClick}>
      <IconClose sx={{ fontSize: 16 }} />
    </IconButton>
  </div>
);

export const UCTCardFile: FC<ICardFileProps & { showDeleteButton?: boolean }> = (props) => {
  const { attachment, name, uploadPercentage, dateInfo, onCancelUpload, showDeleteButton = true } = props;

  const { mutateAsync } = useDeleteAttachment();

  const onClickDelete = async () => {
    if (attachment) {
      await mutateAsync(attachment.id);
    }
  };

  return (
    <div className='mt-24 px-12 py-16 flex items-center gap-12 rounded-6 bg-neutral-10'>
      {onCancelUpload && showDeleteButton && <DeleteButton onClick={onCancelUpload} />}
      {attachment && showDeleteButton && <DeleteButton onClick={onClickDelete} />}
      <div className='w-36'>
        <img src={IconDocument} alt='' className='w-full' />
      </div>
      <div className='flex-1'>
        <div className='flex items-center mb-6'>
          <p className='text-14'>{name}</p>
          {uploadPercentage && !dateInfo && <p className='ml-auto text-12 text-blue_grey-50'>{uploadPercentage}%</p>}
          {dateInfo && <p className='ml-auto text-12 font-semibold text-primary'>{dateInfo}</p>}
        </div>

        <div className='mt-8 w-full h-[5px] rounded-40 bg-neutral-20'>
          <div className='h-full rounded-40 bg-green-50' style={{ width: uploadPercentage ? `${uploadPercentage}%` : `100%` }} />
        </div>
      </div>
    </div>
  );
};
